import * as React from 'react'
import { ServerErrorConnected } from './ServerErrorConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const ServerErrorExamples = () => {
  return (
    <div className="ServerErrorExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <ServerErrorConnected />
      </Provider>
    </div>
  )
}
